import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';

export function GamesHeader() {
  return (
    <div className="flex items-center justify-between gap-4 mb-8">
      {/* Title */}
      <h1 className="text-2xl sm:text-3xl font-bold text-white">
        Your games
      </h1>

      {/* New Game CTA */}
      <Link
        to="/new-game"
        className="flex items-center gap-2 px-4 py-2.5 bg-white text-black rounded-lg text-sm font-medium hover:bg-neutral-200 transition-colors shadow-lg shadow-white/10"
      >
        <Plus className="w-4 h-4" />
        <span>New game</span>
      </Link>
    </div>
  );
}
